export default __webpack_public_path__ + "static/media/hearing-loss-simulator.dae94869.svg";